import Breadcrumb from '@/components/breadcrumb';
import { Button } from '@/components/ui/button';
import { useStore } from '@nanostores/react';
import { PlusIcon } from 'lucide-react';
import { NewWorkflowDrawer } from '../workflow/components/NewWorkflowDrawer';
import { NewProjectDrawer } from './components/NewProjectDrawer';
import { ProjectListing } from './components/ProjectListing';

export const ManageProjects = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [showWorkflowDrawer, setShowWorkflowDrawer] = useState(false);

  const org = useStore($org);

  const ws = useStore($workspace);
  const page = useStore($router);

  const pages = [
    {
      label: org?.name || 'Organizations',
      href: org?.name
        ? `/organization/${org?.id}/workspaces`
        : '/organizations',
    },
    {
      label: ws?.workspace?.name
        ? `${ws.workspace.name} Workspace`
        : 'Workspace',
      href: ws?.workspace?.name
        ? `/organization/${org?.id}/workspace/${ws?.workspace.id}/projects`
        : `/organization/${org?.id}/workspaces`,
    },

    // {
    //   label: 'Projects',
    //   href: `/organization/${org?.id}/workspace/${ws?.workspace.id}/projects`,
    // },
  ];

  return (
    <div>
      {/* Breadcrumb */}
      <h3 className="m-0 flex-1 p-0">
        <Breadcrumb pages={pages} />
      </h3>

      {/* Page Header with actions */}
      <div className=" mt-2 flex items-center justify-between space-y-2">
        <div>
          <h2 className="text-2xl font-bold tracking-tight">{`${ws?.workspace.name} Workspace`}</h2>
          <p className="text-muted-foreground">
            {`List of projects for ${ws?.workspace.name} Workspace`}
          </p>
        </div>
        <div className="flex items-center space-x-2">
          <Button onClick={() => setShowDrawer(true)}>
            <PlusIcon className="mr-2 h-4 w-4" /> Add New
          </Button>
        </div>
      </div>

      {/* Project list */}
      <div className="mt-4 max-w-6xl">
        <ProjectListing />
      </div>

      {/* Create New Project Drawer */}
      <NewProjectDrawer open={showDrawer} setOpen={setShowDrawer} />

      {/* Create New Workflow Drawer */}
      <NewWorkflowDrawer
        open={showWorkflowDrawer}
        setOpen={setShowWorkflowDrawer}
      />
    </div>
  );
};
